import React, { useEffect, useState, useRef } from "react";
import {
  LoadingWrapper,
  LoaderContainer,
  LogoContainer,
  Spinner,
} from "../styles/components/loader";
import animations from "../animations/animations";

const Loader = ({ isLoaded }) => {
  const [minimumTimePassed, setMinimumTimePassed] = useState(false);
  const [isVisibile, setIsVisible] = useState(true);

  const loadingRef = useRef(null);
  const minimumTime = 2000;

  const toggleScroll = state => {
    const element =
      document.querySelector("#hs-web") || document.querySelector("#hs-app");
    if (element) {
      element.style.overflow = state;
    } else {
      document.body.style.overflow = state;
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    toggleScroll("hidden");

    const timer = setTimeout(() => setMinimumTimePassed(true), minimumTime);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!minimumTimePassed || !isLoaded) return;

    animations.to(loadingRef.current, {
      duration: 0.25,
      opacity: 0,
      onComplete: () => {
        document.querySelector("#landing-wrapper")?.classList.add("active");
        toggleScroll("unset");
        setIsVisible(false);
      },
    });
  }, [isLoaded, minimumTimePassed]);

  return (
    <LoadingWrapper ref={loadingRef} $isVisibile={isVisibile}>
      <LoaderContainer>
        <LogoContainer>
          <svg width={72} height={72} viewBox="0 0 72 72">
            <path
              fill="#FFFFFF"
              d="M16 22.461V50.21h5.841V37.988h6.572v12.221h5.842V22.461h-5.842v10.992h-6.572V22.46H16zm40.211 6.918c0-2.537-.307-7.379-8.032-7.379-5.38 0-9.185 2.267-9.185 7.379 0 4.112 1.653 5.842 5.227 8.032l3.459 2.114c1.575.96 3.035 1.653 3.035 3.92 0 1.96-1.114 3.075-3.074 3.075-2.344 0-3.151-1.384-3.151-4.15v-.731h-5.88v1.73c0 3.612 1.614 7.34 8.416 7.34 6.456 0 9.531-2.652 9.531-7.994 0-3.036-.846-4.88-4.266-7.033l-5.61-3.574c-1.23-.769-1.768-1.807-1.768-2.96 0-1.844 1.114-3.074 2.805-3.074 1.845 0 2.805 1.23 2.805 3.612v.654h5.688v-.961z"
            />
          </svg>
          <Spinner />
        </LogoContainer>
      </LoaderContainer>
    </LoadingWrapper>
  );
};

export default Loader;
